const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-rbac/resource.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { ResListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-rbac/res-page';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-rbac/resource')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: ResListFilterParamSchema
});